import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useKeycloak} from '@react-keycloak/web'
import {PageTitle} from '../../../_metronic/layout/core'
import {StatisticsWidget5, AlteracoesFichasWidget} from '../../../_metronic/partials/widgets'
import {AuthorizedFunction} from '../../modules/auth/components/AuthorizedFunction'

const DashboardPage = () => {
  const {keycloak} = useKeycloak()
  const firstName: string | undefined = keycloak?.tokenParsed?.given_name

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]} description='Sala dos Devas'>
        Principal
      </PageTitle>

      {/* begin::Hero */}
      <div className='card border-0 bg-brand-gradient mb-5 mb-xl-8 overflow-hidden'>
        <div className='card-body d-flex flex-wrap align-items-center justify-content-between py-8 px-10'>
          <div className='me-5'>
            <div className='fs-2hx fw-bolder text-white mb-2'>
              Salve Deus{firstName ? `, ${firstName}` : ''}!
            </div>
            <div className='fs-5 fw-semibold text-white opacity-75'>
              Bem-vindo(a) ao Sistema de Gestão OSOEC - Vale do Amanhecer
            </div>
            <div className='fs-6 fw-semibold text-white opacity-75'>Templo Mãe Brasília-DF</div>
          </div>
        </div>
      </div>
      {/* end::Hero */}

      {/* begin::Row — Atalhos */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            svgIcon='magnifier'
            color='primary'
            iconColor='white'
            title='Pesquisa de Médiuns'
            titleColor='white'
            description='Ficha, Emissão, Classificação'
            descriptionColor='white'
            navigateTo='/app/management/medium/search'
          />
        </div>

        {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='geolocation'
              color='primary'
              iconColor='white'
              title='Templos do Amanhecer'
              titleColor='white'
              descriptionColor='white'
              description='Presidentes, Termos, Estatuto'
              navigateTo='/app/management/templo/search'
            />
          </div>
        )}

        {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='flag'
              color='primary'
              iconColor='white'
              title='Sala dos Devas'
              titleColor='white'
              descriptionColor='white'
              description='Cadastro, Escala'
              navigateTo='/app/management/devas/escala'
            />
          </div>
        )}
      </div>
      {/* end::Row */}

      {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
        <div className='g-5 gx-xxl-8'>
          <AlteracoesFichasWidget className='' />
        </div>
      )}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
